module.exports = __webpack_public_path__ + "img/c948cf1.jpg";